'use strict';

angular.module('far.discipline')
    .controller('DisciplineIndexController', function ($log, $http) {
        var vm = {
            progress: true,
            events: {},
            construct: function (discipline) {
                vm.form = { id: discipline };
                getEvents(discipline);
            }
        };

        function getEvents(discipline) {
            $http.get(Routing.generate('api_discipline_get_discipline_events', {discipline: discipline}))
                .then(function (response) {
                    vm.events = angular.merge({}, response.data);
                    vm.progress = false;
                }, function errorCallback(response) {
                    $log.error(response);
                    showModalMessage('Невозможно загрузить мероприятия.');
                });

            return vm.data;
        }

        return vm;
    });